interface BetaUsersFilterBarProps {
  value: string;
  onChange: (value: string) => void;
  count: number;
}

// Design: Beta Users Admin — search/filter bar with a right-aligned
// count of the filtered list.
export function BetaUsersFilterBar({ value, onChange, count }: BetaUsersFilterBarProps) {
  return (
    <div className="mb-3 flex items-center justify-between gap-2">
      <div className="relative flex flex-1 items-center">
        <div className="pointer-events-none absolute left-2.5 flex text-wolisho-brown/30">
          <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        </div>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Filter by name or email…"
          data-testid="beta-users-filter"
          className="w-full rounded-lg border border-wolisho-brown/10 bg-wolisho-brown/[0.02] py-2 pl-8 pr-2.5 text-[13px] text-black outline-hidden transition-colors"
        />
      </div>
      <span
        className="shrink-0 whitespace-nowrap text-xs font-bold text-black/35"
        data-testid="beta-users-count"
      >
        {count} {count === 1 ? 'user' : 'users'}
      </span>
    </div>
  );
}
